import { useRequest } from 'ahooks'
import { useSearchParams } from 'react-router-dom'

import { Table } from '@sar/component'
import { UploadImage } from 'components'

import { Spin } from 'antd'
import { ProForm } from '@ant-design/pro-components'

export default function ({ store, params, navigator }) {
  const [ query ] = useSearchParams()

  const res = useRequest<any, any>(() => {
    if (query.get('isDealer') == 'yes') {
      return store.externals.api.get(`/dealer/info/${params.id}`)
    }

    else {
      return store.externals.api.get(`/orders/info/${params.id}`)
    }
  }, {
    refreshDeps: [ params.id ],
    cacheKey: `/orders/info/${params.id}`,
  })

  const getSearchParams = React.useCallback(type => {
    if (res.data == null) {
      return ''
    }

    let getSelected = () => {
      if ([ 'assembling', 'end' ].includes(res.data.status) == false) {
        return '0'
      }

      else if (type == 'delivery') {
        return res.data.goodsDelivery.sendStatus == 1 ? '1' : '0'
      }

      else {
        return res.data.goodsDelivery.installStatus == 1 ? '1' : '0'
      }
    }

    let data = [
      [ 'selected', getSelected() ],
      [ 'receiver', res.data.goodsDelivery?.receiver ],
      [ 'phoneNumber', res.data.goodsDelivery?.phoneNumber ],
      [ 'deliveryAddress', res.data.goodsDelivery?.deliveryAddress ],
    ]

    return new URLSearchParams(data.filter(([ _, value ]) => value)).toString()
  }, [ res.data ])

  if (query.get('isDealer') == 'yes') {
    return <div className='p-4 m-4 bg-white'>
      <Spin spinning={res.loading} tip='加载中...'>
        <table className='w-full border-collapse border border-slate-300'>
          <thead>
            <tr>
              <th colSpan={6} className='border border-slate-300 text-left p-3 bg-gray-200'>基本信息</th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td className='border border-slate-300 text-center p-3 w-1/6 bg-gray-100'>订单编号</td>
              <td className='border border-slate-300 text-center p-3 w-1/6 bg-gray-100'>客户姓名</td>
              <td className='border border-slate-300 text-center p-3 w-1/6 bg-gray-100'>联系电话</td>
              <td className='border border-slate-300 text-center p-3 w-1/6 bg-gray-100'>订单来源</td>
              <td className='border border-slate-300 text-center p-3 w-1/6 bg-gray-100'>支付方式</td>
              <td className='border border-slate-300 text-center p-3 w-1/6 bg-gray-100'>总金额</td>
            </tr>

            <tr>
              <td className='border border-slate-300 text-center p-3 w-1/6'>{res.data?.number}</td>
              <td className='border border-slate-300 text-center p-3 w-1/6'>{res.data?.customerName}</td>
              <td className='border border-slate-300 text-center p-3 w-1/6'>{res.data?.customerPhone}</td>
              <td className='border border-slate-300 text-center p-3 w-1/6'>{res.data?.customerSource}</td>
              <td className='border border-slate-300 text-center p-3 w-1/6'>{res.data?.payStatus}</td>
              <td className='border border-slate-300 text-center p-3 w-1/6'>{res.data?.totalAmount}</td>
            </tr>

            <tr>
              <td className='border border-slate-300 text-center p-3 w-1/6 bg-gray-100'>预订金额</td>
              <td className='border border-slate-300 text-center p-3 w-1/6 bg-gray-100'>生产类型</td>
              <td className='border border-slate-300 text-center p-3 w-1/6 bg-gray-100'>尾款金额</td>
              <td className='border border-slate-300 text-center p-3 w-1/6 bg-gray-100'>跟踪员</td>
              <td className='border border-slate-300 text-center p-3 w-1/6 bg-gray-100'>预计交付时间</td>
              <td className='border border-slate-300 text-center p-3 w-1/6 bg-gray-100'>实际交付时间</td>
            </tr>

            <tr>
              <td className='border border-slate-300 text-center p-3 w-1/6'>{res.data?.depositAmount}</td>
              <td className='border border-slate-300 text-center p-3 w-1/6'>{store.config.getConstantDescriptByValue('OrderType', res.data?.type)}</td>
              <td className='border border-slate-300 text-center p-3 w-1/6'>{R.defaultTo(0, res.data?.totalAmount) - R.defaultTo(0, res.data?.paidAmount)}</td>
              <td className='border border-slate-300 text-center p-3 w-1/6'>{res.data?.saleName}</td>
              <td className='border border-slate-300 text-center p-3 w-1/6'>{res.data?.estimatedShipmentDate}</td>
              <td className='border border-slate-300 text-center p-3 w-1/6'>{res.data?.deliveryConfirmationDate}</td>
            </tr>
          </tbody>
        </table>

        <table className='w-full border-collapse border border-slate-300 mt-8'>
          <thead>
            <tr>
              <th colSpan={7} className='border border-slate-300 text-left p-3 bg-gray-200'>订单信息</th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td className='border border-slate-300 text-center p-3 bg-gray-100'>1</td>
              <td className='border border-slate-300 text-center p-3 bg-gray-100'>跟单员</td>
              <td className='border border-slate-300 text-center p-3'>{res.data?.saleName}</td>
              <td className='border border-slate-300 text-center p-3 bg-gray-100'>时间</td>
              <td className='border border-slate-300 text-center p-3'>{res.data?.createTime}</td>
            </tr>

            <tr>
              <td className='border border-slate-300 text-center p-3 bg-gray-100'>2</td>
              <td className='border border-slate-300 text-center p-3 bg-gray-100'>设计员</td>
              <td className='border border-slate-300 text-center p-3'>{res.data?.designerName}</td>
              <td className='border border-slate-300 text-center p-3 bg-gray-100'>时间</td>
              <td className='border border-slate-300 text-center p-3'>{res.data?.designerTime}</td>
            </tr>

            <tr>
              <td className='border border-slate-300 text-center p-3 bg-gray-100'>3</td>
              <td className='border border-slate-300 text-center p-3 bg-gray-100'>报价员</td>
              <td className='border border-slate-300 text-center p-3'>{res.data?.quoteName}</td>
              <td className='border border-slate-300 text-center p-3 bg-gray-100'>时间</td>
              <td className='border border-slate-300 text-center p-3'>{res.data?.quoteTime}</td>
            </tr>

            <tr>
              <td className='border border-slate-300 text-center p-3 bg-gray-100'>4</td>
              <td className='border border-slate-300 text-center p-3 bg-gray-100'>拆单员</td>
              <td className='border border-slate-300 text-center p-3'>{res.data?.splitterName}</td>
              <td className='border border-slate-300 text-center p-3 bg-gray-100'>时间</td>
              <td className='border border-slate-300 text-center p-3'>{res.data?.splitterTime}</td>
            </tr>

            {
              ![ '1', '2', '3', '7', '8' ].includes(res.data?.type)  ? null : (
                <tr>
                  <td className='border border-slate-300 text-center p-3 bg-gray-100'>5</td>
                  <td className='border border-slate-300 text-center p-3 bg-gray-100 font-bold'>生产</td>
                  <td colSpan={5} className='border border-slate-300 bg-gray-100'></td>
                </tr>
              )
            }

            {
              ![ '2', '3', '8' ].includes(res.data?.type) ? null : (
                <tr>
                  <td className='border border-slate-300 text-center p-3 bg-gray-100'>6</td>
                  <td className='border border-slate-300 text-center p-3 bg-gray-100'>原木</td>
                  <td className='border border-slate-300 text-center p-3'>{res.data?.producerName}</td>
                  <td className='border border-slate-300 text-center p-3 bg-gray-100'>时间</td>
                  <td className='border border-slate-300 text-center p-3'>{res.data?.orderWoodlogFlows?.updateTime}</td>
                </tr>
              )
            }

            {
              ![ '1', '3', '7' ].includes(res.data?.type) ? null : (
                <tr>
                  <td className='border border-slate-300 text-center p-3 bg-gray-100'>7</td>
                  <td className='border border-slate-300 text-center p-3 bg-gray-100'>板式</td>
                  <td className='border border-slate-300 text-center p-3'>{res.data?.producerName}</td>
                  <td className='border border-slate-300 text-center p-3 bg-gray-100'>时间</td>
                  <td className='border border-slate-300 text-center p-3'>{res.data?.orderBoardFlows?.updateTime}</td>
                </tr>
              )
            }

            <tr>
              <td className='border border-slate-300 text-center p-3 bg-gray-100'>
                {
                    res.data?.type >= 4 ? 8 - 3
                  : res.data?.type == 3 ? 8 - 0
                  : res.data?.type == 2 ? 8 - 2 : 8 - 2
                }
              </td>
              <td className='border border-slate-300 text-center p-3 bg-gray-100'>配送</td>
              <td className='border border-slate-300 text-center p-3'>{res.data?.goodsDelivery?.sendPeople}</td>
              <td className='border border-slate-300 text-center p-3 bg-gray-100'>时间</td>
              <td className='border border-slate-300 text-center p-3'>{res.data?.goodsDelivery?.sendTime}</td>
            </tr>

            <tr>
              <td className='border border-slate-300 text-center p-3 bg-gray-100'>
                {
                    res.data?.type >= 4 ? 9 - 3
                  : res.data?.type == 3 ? 9 - 0
                  : res.data?.type == 2 ? 9 - 2 : 9 - 2
                }
              </td>
              <td className='border border-slate-300 text-center p-3 bg-gray-100'>安装</td>
              <td className='border border-slate-300 text-center p-3'>{res.data?.goodsDelivery?.installPeople}</td>
              <td className='border border-slate-300 text-center p-3 bg-gray-100'>时间</td>
              <td className='border border-slate-300 text-center p-3'>{res.data?.goodsDelivery?.installTime}</td>
            </tr>
          </tbody>
        </table>
      </Spin>
    </div>
  }

  return <div className='p-4 m-4 bg-white'>
    <Spin spinning={res.loading} tip='加载中...'>
      <table className='w-full border-collapse border border-slate-300'>
        <thead>
          <tr>
            <th colSpan={7} className='border border-slate-300 text-left p-3 bg-gray-200'>基本信息</th>
          </tr>
        </thead>

        <tbody>
          <tr>
            <td className='border border-slate-300 text-center p-3 w-[14.28%] bg-gray-100'>订单编号</td>
            <td className='border border-slate-300 text-center p-3 w-[14.28%] bg-gray-100'>客户姓名</td>
            <td className='border border-slate-300 text-center p-3 w-[14.28%] bg-gray-100'>联系电话</td>
            <td className='border border-slate-300 text-center p-3 w-[14.28%] bg-gray-100'>订单来源</td>
            <td className='border border-slate-300 text-center p-3 w-[14.28%] bg-gray-100'>支付方式</td>
            <td className='border border-slate-300 text-center p-3 w-[14.28%] bg-gray-100'>总金额</td>
            <td className='border border-slate-300 text-center p-3 w-[14.28%] bg-gray-100'>拆单二维码</td>
          </tr>

          <tr>
            <td className='border border-slate-300 text-center p-3 w-[14.28%]'>{res.data?.number}</td>
            <td className='border border-slate-300 text-center p-3 w-[14.28%]'>{res.data?.customerName}</td>
            <td className='border border-slate-300 text-center p-3 w-[14.28%]'>{res.data?.customerPhone}</td>
            <td className='border border-slate-300 text-center p-3 w-[14.28%]'>{res.data?.customerSource}</td>
            <td className='border border-slate-300 text-center p-3 w-[14.28%]'>{res.data?.payStatus}</td>
            <td className='border border-slate-300 text-center p-3 w-[14.28%]'>{res.data?.totalAmount}</td>

            <td rowSpan={3} className='border border-slate-300 text-center p-3'>
              <div className='flex justify-center'>
                <UploadImage.WithoutFormItem
                  readonly
                  value={res.data?.fileManageList?.filter(e => e.type == 'splitQRCode')}
                />
              </div>
            </td>
          </tr>

          <tr>
            <td className='border border-slate-300 text-center p-3 w-[14.28%] bg-gray-100'>预订金额</td>
            <td className='border border-slate-300 text-center p-3 w-[14.28%] bg-gray-100'>生产类型</td>
            <td className='border border-slate-300 text-center p-3 w-[14.28%] bg-gray-100'>尾款金额</td>
            <td className='border border-slate-300 text-center p-3 w-[14.28%] bg-gray-100'>跟单员</td>
            <td className='border border-slate-300 text-center p-3 w-[14.28%] bg-gray-100'>预计交付时间</td>
            <td className='border border-slate-300 text-center p-3 w-[14.28%] bg-gray-100'>实际交付时间</td>
          </tr>

          <tr>
            <td className='border border-slate-300 text-center p-3 w-[14.28%]'>{res.data?.depositAmount}</td>
            <td className='border border-slate-300 text-center p-3 w-[14.28%]'>{store.config.getConstantDescriptByValue('OrderType', res.data?.type)}</td>
            <td className='border border-slate-300 text-center p-3 w-[14.28%]'>{R.defaultTo(0, res.data?.totalAmount) - R.defaultTo(0, res.data?.paidAmount)}</td>
            <td className='border border-slate-300 text-center p-3 w-[14.28%]'>{res.data?.saleName}</td>
            <td className='border border-slate-300 text-center p-3 w-[14.28%]'>{res.data?.estimatedShipmentDate}</td>
            <td className='border border-slate-300 text-center p-3 w-[14.28%]'>{res.data?.deliveryConfirmationDate}</td>
          </tr>
        </tbody>
      </table>

      <table className='w-full border-collapse border border-slate-300 mt-8'>
        <thead>
          <tr>
            <th colSpan={9} className='border border-slate-300 text-left p-3 bg-gray-200'>订单信息</th>
          </tr>
        </thead>

        <tbody>
          <tr>
            <td className='border border-slate-300 text-center p-3 bg-gray-100'>1</td>
            <td className='border border-slate-300 text-center p-3 bg-gray-100'>跟单员</td>
            <td className='border border-slate-300 text-center p-3'>{res.data?.saleName}</td>
            <td className='border border-slate-300 text-center p-3 bg-gray-100'>时间</td>
            <td className='border border-slate-300 text-center p-3'>{res.data?.createTime}</td>
            <td className='border border-slate-300 text-center p-3 bg-gray-100'>文件</td>
            <td className='border border-slate-300 text-center p-3'>
              <a onClick={() => navigator.to(`/customer/list/update/${res.data?.customerId}`, `查看客户（${res.data?.customerName}）`)}>查看</a>
            </td>
          </tr>

          <tr>
            <td className='border border-slate-300 text-center p-3 bg-gray-100'>2</td>
            <td className='border border-slate-300 text-center p-3 bg-gray-100'>设计员</td>
            <td className='border border-slate-300 text-center p-3'>{res.data?.designerName}</td>
            <td className='border border-slate-300 text-center p-3 bg-gray-100'>时间</td>
            <td className='border border-slate-300 text-center p-3'>{res.data?.designerTime}</td>
            <td className='border border-slate-300 text-center p-3 bg-gray-100'>文件</td>
            <td className='border border-slate-300 text-center p-3'>
              <a onClick={() => navigator.to(`/design/list/upload/${res.data?.id}`, `查看设计（${res.data?.customerName}）`)}>查看</a>
            </td>
          </tr>

          <tr>
            <td className='border border-slate-300 text-center p-3 bg-gray-100'>3</td>
            <td className='border border-slate-300 text-center p-3 bg-gray-100'>报价员</td>
            <td className='border border-slate-300 text-center p-3'>{res.data?.quoteName}</td>
            <td className='border border-slate-300 text-center p-3 bg-gray-100'>时间</td>
            <td className='border border-slate-300 text-center p-3'>{res.data?.quoteTime}</td>
            <td className='border border-slate-300 text-center p-3 bg-gray-100'>文件</td>
            <td className='border border-slate-300 text-center p-3'>
              <a onClick={() => navigator.to(`/price/list/receipt/${res.data?.id}`, `查看报价（${res.data?.customerName}）`)}>查看</a>
            </td>
          </tr>

          <tr>
            <td className='border border-slate-300 text-center p-3 bg-gray-100'>4</td>
            <td className='border border-slate-300 text-center p-3 bg-gray-100'>拆单员</td>
            <td className='border border-slate-300 text-center p-3'>{res.data?.splitterName}</td>
            <td className='border border-slate-300 text-center p-3 bg-gray-100'>时间</td>
            <td className='border border-slate-300 text-center p-3'>{res.data?.splitterTime}</td>
            <td className='border border-slate-300 text-center p-3 bg-gray-100'>文件</td>
            <td className='border border-slate-300 text-center p-3'>
              <a onClick={() => navigator.to(`/split/list/upload/${res.data?.id}`, `查看拆单（${res.data?.customerName}）`)}>查看</a>
            </td>
          </tr>

          {
            ![ '1', '2', '3', '7', '8' ].includes(res.data?.type)   ? null : (
              <tr>
                <td className='border border-slate-300 text-center p-3 bg-gray-100'>5</td>
                <td className='border border-slate-300 text-center p-3 bg-gray-100'>生产</td>
                <td colSpan={7} className='border border-slate-300 bg-gray-100'></td>
              </tr>
            )
          }

          {
            ![ '2', '3', '8' ].includes(res.data?.type) ? null : (
              <tr>
                <td className='border border-slate-300 text-center p-3 bg-gray-100'>6</td>
                <td className='border border-slate-300 text-center p-3 bg-gray-100'>原木</td>
                <td className='border border-slate-300 text-center p-3'>{res.data?.producerName}</td>
                <td className='border border-slate-300 text-center p-3 bg-gray-100'>时间</td>
                <td className='border border-slate-300 text-center p-3'>{res.data?.orderWoodlogFlows?.updateTime}</td>
                <td className='border border-slate-300 text-center p-3 bg-gray-100'>文件</td>
                <td className='border border-slate-300 text-center p-3'>
                  <a onClick={() => navigator.to(`/production/list/detail/${res.data?.id}/${res.data?.type}`, `查看生产（${res.data?.customerName}）`)}>查看</a>
                </td>
              </tr>
            )
          }

          {
            ![ '1', '3', '7' ].includes(res.data?.type) ? null : (
              <tr>
                <td className='border border-slate-300 text-center p-3 bg-gray-100'>7</td>
                <td className='border border-slate-300 text-center p-3 bg-gray-100'>板式</td>
                <td className='border border-slate-300 text-center p-3'>{res.data?.producerName}</td>
                <td className='border border-slate-300 text-center p-3 bg-gray-100'>时间</td>
                <td className='border border-slate-300 text-center p-3'>{res.data?.orderBoardFlows?.updateTime}</td>
                <td className='border border-slate-300 text-center p-3 bg-gray-100'>文件</td>
                <td className='border border-slate-300 text-center p-3'>
                  <a onClick={() => navigator.to(`/production/list/detail/${res.data?.id}/${res.data?.type}`, `查看生产（${res.data?.customerName}）`)}>查看</a>
                </td>
              </tr>
            )
          }

          <tr>
            <td className='border border-slate-300 text-center p-3 bg-gray-100'>
              {
                  res.data?.type >= 4 ? 8 - 3
                : res.data?.type == 3 ? 8 - 0
                : res.data?.type == 2 ? 8 - 2 : 8 - 2
              }
            </td>
            <td className='border border-slate-300 text-center p-3 bg-gray-100'>配送</td>
            <td className='border border-slate-300 text-center p-3'>{res.data?.goodsDelivery?.sendPeople}</td>
            <td className='border border-slate-300 text-center p-3 bg-gray-100'>时间</td>
            <td className='border border-slate-300 text-center p-3'>{res.data?.goodsDelivery?.sendTime}</td>
            <td className='border border-slate-300 text-center p-3 bg-gray-100'>文件</td>
            <td className='border border-slate-300 text-center p-3'>
              <a onClick={() => navigator.to(`/assembly/delivery?${getSearchParams('delivery')}`, `配送列表`)}>查看</a>
            </td>
          </tr>

          <tr>
            <td className='border border-slate-300 text-center p-3 bg-gray-100'>
              {
                  res.data?.type >= 4 ? 9 - 3
                : res.data?.type == 3 ? 9 - 0
                : res.data?.type == 2 ? 9 - 2 : 9 - 2
              }
            </td>
            <td className='border border-slate-300 text-center p-3 bg-gray-100'>安装</td>
            <td className='border border-slate-300 text-center p-3'>{res.data?.goodsDelivery?.installPeople}</td>
            <td className='border border-slate-300 text-center p-3 bg-gray-100'>时间</td>
            <td className='border border-slate-300 text-center p-3'>{res.data?.goodsDelivery?.installTime}</td>
            <td className='border border-slate-300 text-center p-3 bg-gray-100'>文件</td>
            <td className='border border-slate-300 text-center p-3'>
              <a onClick={() => navigator.to(`/assembly/install?${getSearchParams('install')}`, `安装列表`)}>查看</a>
            </td>
          </tr>
        </tbody>
      </table>

      {
        R.isNil(res.data?.afterSales) || R.isEmpty(res.data?.afterSales) ? null : (
          <table className='w-full border-collapse border border-slate-300 mt-8'>
            <thead>
              <tr>
                <th colSpan={3} className='border border-slate-300 text-left p-3 bg-gray-200'>售后信息</th>
              </tr>

              <tr>
                <td className='border border-slate-300 text-left p-3 bg-gray-100'>售后状态</td>
                <td className='border border-slate-300 text-left p-3 bg-gray-100'>创建时间</td>
                <td className='border border-slate-300 text-left p-3 bg-gray-100'>问题描述</td>
              </tr>
            </thead>

            <tbody>
              {res.data?.afterSales?.map(data => {
                return <tr key={data.id}>
                  <td className='border border-slate-300 text-left p-3 bg-white'>{data.status == 'yes' ? '已结束' : '处理中'}</td>
                  <td className='border border-slate-300 text-left p-3 bg-white'>{data.createTime}</td>
                  <td className='border border-slate-300 text-left p-3 bg-white'>{data.describes}</td>
                </tr>
              })}
            </tbody>
          </table>
        )
      }
    </Spin>
  </div>
}
